import { memo } from 'react';
import { Lock, Box } from 'lucide-react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { EditorNode } from '../domain/editor-graph';

export const FallbackNode = memo(function FallbackNode({ data, selected }: NodeProps<EditorNode>) {
  const label = typeof data.label === 'string' && data.label.trim() ? data.label : 'Nó genérico';
  const originalType =
    typeof data.__editorOriginalType === 'string' ? data.__editorOriginalType : 'desconhecido';
  const locked = Boolean(data.__editorLocked);

  return (
    <div
      className={`min-w-[190px] rounded-lg border bg-[#111412] px-4 py-3 shadow-xl transition-colors ${
        selected ? 'border-accent' : 'border-border'
      }`}
      data-testid="editor-node"
    >
      <Handle
        type="target"
        position={Position.Left}
        isConnectable={false}
        className="!h-2 !w-2 !border !border-[#c69032] !bg-[#111412]"
      />
      <div className="flex items-center gap-2 text-text-primary">
        <Box aria-hidden size={15} className="text-[#c69032]" />
        <span className="max-w-[150px] truncate text-sm font-medium">{label}</span>
        {locked ? <Lock aria-label="Bloqueado" size={13} className="ml-auto text-text-muted" /> : null}
      </div>
      <div className="mt-2 font-mono text-[10px] uppercase tracking-wider text-text-muted">
        {originalType}
      </div>
      <Handle
        type="source"
        position={Position.Right}
        isConnectable={false}
        className="!h-2 !w-2 !border !border-[#c69032] !bg-[#111412]"
      />
    </div>
  );
});
